"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TopBarAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withWindowDimensions = _interopRequireDefault(require("../../../../util/withWindowDimensions"));
var _PropTypeCustomAction = require("../../header/prop-type-custom-action/PropTypeCustomAction");
var _CustomIcon = _interopRequireDefault(require("../custom/CustomIcon"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _AppConstants = _interopRequireDefault(require("../../../../constants/AppConstants"));
var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));
var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));
require("!style-loader!css-loader!./TopBarAction.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const DISPLAY_WITH_LABEL_THRESHOLD = 768;
const TopBarAction = ({
  action,
  windowDimensions,
  inActiveLabel
}) => {
  const {
    displayWithLabel,
    label,
    selected,
    isSelected,
    disabled,
    onClick,
    id,
    Icon,
    variant,
    toolTipPlacement
  } = action;
  let iconObj = Icon;
  if (id === "readAloudStart") {
    iconObj = /*#__PURE__*/_react.default.createElement(_CustomIcon.default, {
      url: Icon
    });
  }
  const shouldDisplayLabel = windowDimensions && windowDimensions.width >= DISPLAY_WITH_LABEL_THRESHOLD && displayWithLabel;
  const buttonStyles = {
    quiet: !displayWithLabel,
    label: shouldDisplayLabel ? label : null,
    "background-color": "#f5f5f5 !important"
  };
  let displayLabel = label;
  let trigger = "hover";
  let delayShow = 1000;
  let shouldDisable = disabled;
  if (typeof label === "object") {
    displayLabel = label.id || id;
  }
  // making toolitem inactive to use
  // current use case: shared commenting in ms teams
  if (inActiveLabel) {
    displayLabel = inActiveLabel;
    trigger = "click";
    delayShow = 0;
    shouldDisable = false;
  }
  const sendOnClickAnalytics = () => {
    const workflow = id;
    const subcategory = _AppConstants.default.SUBCATEGORY_USE;
    const type = _AppConstants.default.SUBCATEGORY_TYPE_CLICK;
    let subtype;
    if (isSelected !== undefined) {
      subtype = isSelected ? "Disabled" : "Enabled";
    }
    if (inActiveLabel) {
      subtype = "Inactive";
    }
    const event = {
      workflow,
      subcategory,
      type,
      subtype
    };
    _ServiceRegistry.default.getService("AnalyticsProviderService").logEvent(event);
  };
  const onClickHandler = () => {
    _ServiceRegistry.default.getService("AppStore").setLastAnnotationToolClicked(id);
    try {
      sendOnClickAnalytics();
      if (!inActiveLabel) {
        onClick();
      }
    } catch (error) {
      _ServiceRegistry.default.getService("LoggingService").error("TopBarAction", `The ${id} action in the navigation bar threw an error`, error);
    }
  };
  const placement = toolTipPlacement || "bottom";

  // OverlayTrigger overrides onClick of child prop in case trigger is "click", therefore conditionally passing props.
  const overlayOnClickProp = {};
  const buttonOnClickProp = {};
  if (trigger === "click") {
    overlayOnClickProp.onClick = () => onClickHandler();
  } else {
    buttonOnClickProp.onClick = () => onClickHandler();
  }
  return /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, _extends({
    delayShow: delayShow,
    trigger: trigger,
    placement: placement
  }, overlayOnClickProp), /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    id: id
  }, buttonStyles, {
    variant: variant || "tool",
    selected: selected,
    icon: iconObj,
    disabled: shouldDisable
  }, buttonOnClickProp, {
    "aria-label": displayLabel
  })), /*#__PURE__*/_react.default.createElement(_Tooltip.default, null, displayLabel));
};
exports.TopBarAction = TopBarAction;
TopBarAction.propTypes = {
  action: _PropTypeCustomAction.propTypeJsonCustomAction.isRequired,
  windowDimensions: _propTypes.default.objectOf(_propTypes.default.any).isRequired,
  inActiveLabel: _propTypes.default.string
};
TopBarAction.defaultProps = {
  inActiveLabel: ""
};
var _default = exports.default = (0, _withWindowDimensions.default)(TopBarAction);